export const isMac =
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  /Mac|iPod|iPhone|iPad/.test(navigator.userAgent)
export const modKey = isMac ? 'Cmd' : 'Ctrl'
